import React, { useCallback, useEffect, useRef, useState, } from 'react';
import { ArrowDown } from '@yme/assets/icons';
import { useWindowSize } from '@yme/hooks/index';
import { useTranslation } from '@yme/services/i18n';
import { keyCodes } from '@yme/utils/constants';
import { MINIMAL_DIFF_WIDTH } from './constants';
import { ContentWrapper, ExpandingBlockStyled, SVGIconStyled } from './styled';
export function ExpandingBlock({ isRightToLeft, iconType = ArrowDown, children, textColor, }) {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isExpandIconVisible, setIsExpandIconVisible] = useState(false);
    const [heightContent, setHeightContent] = useState(20);
    const contentRef = useRef(null);
    const contentWrapperRef = useRef(null);
    const { width } = useWindowSize();
    const { t } = useTranslation();
    const contentWrapperOrder = isRightToLeft ? 2 : 1;
    const iconOrder = isRightToLeft ? 1 : 2;
    const onClickHandler = useCallback(() => {
        setIsExpanded(!isExpanded);
    }, [isExpanded]);
    const keyDownHandler = useCallback((event) => {
        if (event.key === keyCodes.ENTER) {
            onClickHandler();
        }
    }, [onClickHandler]);
    useEffect(() => {
        if (contentRef?.current && contentWrapperRef?.current) {
            const { width: widthHolderBlock } = contentWrapperRef.current.getBoundingClientRect();
            const { width: widthInnerBlock } = contentRef.current.getBoundingClientRect();
            const lastChild = contentRef?.current.lastChild;
            const { offsetHeight } = lastChild;
            setHeightContent(offsetHeight);
            const diff = widthHolderBlock - widthInnerBlock;
            setIsExpandIconVisible(diff <= MINIMAL_DIFF_WIDTH);
        }
    }, [heightContent, width]);
    return (React.createElement(ExpandingBlockStyled, { ref: contentWrapperRef, isExpanded: isExpanded, heightContent: heightContent },
        React.createElement(ContentWrapper, { ref: contentRef, textColor: textColor, isRightToLeft: isRightToLeft, isExpanded: isExpanded, order: contentWrapperOrder }, children),
        isExpandIconVisible && (React.createElement(SVGIconStyled, { type: iconType, onClick: onClickHandler, isExpanded: isExpanded, order: iconOrder, tabIndex: 0, keyDownHandler: keyDownHandler, isRightToLeft: isRightToLeft, "aria-label": t('common_expandingContent_accessibility') }))));
}
